export default __webpack_public_path__ + "static/media/baccarat2.41abbb2d.png";